import { MyCollapse } from '~/components/ui/MyCollapse'
import { toHtml } from '~/utils'
import { RightOutlined } from '@ant-design/icons'

export default function Guideline({
  buyNote,
  ownerNote,
}: {
  buyNote: string
  ownerNote: string
}) {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-6">规则/须知</h2>
      <MyCollapse
        ghost
        expandIcon={({ isActive }) => (
          <RightOutlined rotate={isActive ? 90 : 0} />
        )}
        expandIconPosition={`right`}
      >
        <MyCollapse.Panel header="购买须知" key="3">
          <div
            dangerouslySetInnerHTML={{
              __html: toHtml(buyNote),
            }}
          />
        </MyCollapse.Panel>
        <MyCollapse.Panel header="版权所有权权益须知" key="2">
          <div
            dangerouslySetInnerHTML={{
              __html: toHtml(ownerNote),
            }}
          />
        </MyCollapse.Panel>
      </MyCollapse>
    </div>
  )
}
